import { render, staticRenderFns } from "./SelectSharingPermissions.vue?vue&type=template&id=fa9fc04c&scoped=true"
import script from "./SelectSharingPermissions.vue?vue&type=script&lang=ts"
export * from "./SelectSharingPermissions.vue?vue&type=script&lang=ts"
import style0 from "./SelectSharingPermissions.vue?vue&type=style&index=0&id=fa9fc04c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9fc04c",
  null
  
)

export default component.exports